/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const useStyles = () => ({
    paper: {
        width: '100%',
        overflowY: 'auto',
        position: 'relative',
        minHeight: '528px',
        height: { xs: '100vh', ta: '75vh' },
        maxHeight: { xs: '100%', ta: '75vh' },
        marginTop: { ta: '15vh' },
        left: { ta: '-9px' },
    },
});
